// "Remind me later" on the Terms prompt lasts for the browser session (so it
// survives a reload), only for the version it was chosen for, and is forgotten
// at logout so the next login asks with the modal again.
const REMIND_LATER_KEY = 'terms-remind-later';

export function remindedLaterFor(): string | null {
  try {
    return sessionStorage.getItem(REMIND_LATER_KEY);
  } catch {
    return null;
  }
}

export function rememberRemindLater(version: string): void {
  try {
    sessionStorage.setItem(REMIND_LATER_KEY, version);
  } catch {
    // Storage unavailable: the banner still shows until the next reload.
  }
}

export function forgetRemindLater(): void {
  try {
    sessionStorage.removeItem(REMIND_LATER_KEY);
  } catch {
    // Storage unavailable: nothing was remembered.
  }
}
